// extracted by mini-css-extract-plugin
export default {"price":"x6-z","onSale":"y6-z","msrpLabelPrice":"z6-z","msrpLabel":"A6-z","originalPrice":"B6-z","percentOff":"C6-z"};